import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";
import CpntContentCGVCGU from "../../../components/CpntContentCGVCGU";
import ModalPrintable from "../../../components/modalPrintable/ModalPrintable";

interface CpntModalConventionProps {
  show: boolean;
  onClose: () => void;
  onAccept: () => void;
}

const CpntModalConvention: React.FC<CpntModalConventionProps> = ({ show, onClose, onAccept }) => {
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const modalBodyRef = useRef<HTMLDivElement>(null);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const element = e.currentTarget;
    const isAtBottom = Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) < 10;
    if (isAtBottom && !hasScrolledToBottom) {
      setHasScrolledToBottom(true);
    }
  };

  const handleClose = () => {
    setHasScrolledToBottom(false);
    onClose();
  };

  const handleAccept = () => {
    setHasScrolledToBottom(false);
    onAccept();
  };

  return (
    <ModalPrintable
      show={show}
      handleClose={handleClose}
      headerText="Conditions générales d'utilisation du site Editeurs Pros et Conditions générales de vente"
      printbutton={true}
      modalsize="xl"
    >
      <div
        ref={modalBodyRef}
        onScroll={handleScroll}
        style={{ maxHeight: "60vh", overflowY: "auto" }}
        className="modal-content-printable"
      >
        <CpntContentCGVCGU />
      </div>
      <div 
        style={{ marginTop: "20px", textAlign: "right", borderTop: "1px solid #dee2e6", paddingTop: "15px" }}
        className="no-print"
      >
        <Button variant="secondary" onClick={handleClose} style={{ marginRight: "10px" }}>
          Fermer
        </Button>
        <Button variant="primary" onClick={handleAccept} disabled={!hasScrolledToBottom}>
          Accepter
        </Button>
      </div>
    </ModalPrintable>
  );
};

export default CpntModalConvention;

